<mat-toolbar class="footer" color="primary">
  <div class="footer-content">
    
    <!-- Logo -->
    <div class="footer-section logo-section">
        <a href="{{configService.settings.domain}}">
            <!--<img src="/assets/img/mylockersite.png" alt="mylocker.site logo" class="logo">-->
            <img class="logo" alt="{{configService.settings.name}}" [src]="configService.settings.logo.imageMedium" [srcset]="
                            configService.settings.logo.imageSmall + ' 200w,
                        ' + configService.settings.logo.imageMedium + ' 400w,
                        ' + configService.settings.logo.imageLarge + ' 800w'
                    "
                    />
            <div class="site-name">{{configService.settings.domain}}</div>
        </a>
    </div>

    <!-- Contacto -->
    <div class="footer-section contact-section">
      <div class="contact-item">
        <mat-icon>send</mat-icon>
        <a href="tel:{{configService.settings.phone}}">{{configService.settings.phone}}</a>
      </div>
      <div class="contact-item">
        <mat-icon>email</mat-icon>
        <a href="mailto:{{configService.settings.email}}">{{configService.settings.email}}</a>
      </div>
    </div>

    <!-- Enlaces -->
    <div class="footer-section links-section">
      <a href="{{configService.settings.domain}}">Blog – English</a>
      <a href="{{configService.settings.domain}}">FAQ</a>
      <a href="{{configService.settings.domain}}">Terms and conditions of use</a>
      <a href="{{configService.settings.domain}}">Privacy policy</a>
      <a href="{{configService.settings.domain}}">Cookie policy</a>
    </div>

  </div>
</mat-toolbar>
